import { joinClasses } from '../../primitives/fieldClassSlots';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { DividerNode } from '../types';

export function Divider({ node }: { node: DividerNode }) {
  return (
    <div
      className={joinClasses('my-3 border-t', node.className)}
      style={layoutInlineStyle(node.style)}
    />
  );
}
